import { JsonObject, JsonProperty } from 'json2typescript';
import { ShopPackTranslation } from './shop-pack-translation.model';
import { ShopPackReward } from './shop-pack-reward.model';
import { ShopPackBooster } from './shop-pack-booster.model';

@JsonObject('ShopPack')
export class ShopPack {

  @JsonProperty('pack_id', Number)
  packId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('date_start_timestamp', Number)
  dateStartTimestamp: number = 0;

  @JsonProperty('date_end_timestamp', Number)
  dateEndTimestamp: number = 0;

  @JsonProperty('shop_item_id', Number)
  shopItemId: number = 0;

  @JsonProperty('translations', [ShopPackTranslation])
  translations: ShopPackTranslation[] = [];

  @JsonProperty('rewards', [ShopPackReward])
  rewards: ShopPackReward[] = [];

  @JsonProperty('boosters', [ShopPackBooster])
  boosters: ShopPackBooster[] = [];
}
